import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { Url } from "../../config/config";
import Pagination from "react-js-pagination";
import { dateFormat } from "../../utils";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useDebounce from "../../hooks/useDebounce";
import DatePicker from "react-datepicker";
import moment from "moment";
import useButtonLoader from "../../hooks/useButtonLoader";

// import axios from 'axios';



const initialState = {};


export default function DocumentVerification() {
  const [users, setUser] = useState([]);
  const [total, setTotal] = useState(0);
  const[limit,setLimit]=useState('10')
  //const [activePage, setActivePage] = useState(1);
  const [requestType, setRequestType] = useState("ReferToFinance");
  const currentActivePage = parseInt(localStorage.getItem('solarActivePage'))
  const [activePage, setActivePage] = useState(currentActivePage || 1);
  //const [isLoading, setIsLoading] = useState(false);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [searchValue, setSearchValue] = useState("");
  const debounceValue = useDebounce(searchValue, 500);

  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    'Download',
    'Please wait...',
  )

  //****************************Handel Solar Request List************************ */
  const handelSolarRequest = async (type = "NotYet", page = 1, query = "") => {
    // e.preventDefault();
    setRequestType(type);
    // console.log("requerst type", type);
    try {
      showLoader();
      const formattedStartDate = startDate !== "" ? new Date(startDate).toISOString() : "";
      const formattedEndDate = endDate !== "" ? new Date(endDate).toISOString() : "";

      const res = await axios({
        url: `${Url}/solarRequest?state=${type}&page=${page}&search=${query}&startDate=${formattedStartDate}&endDate=${formattedEndDate}&limit=${limit}`,
        method: "GET",
      });
      hideLoader();
      console.log(res.data.data);
      //console.log(res.data.data.total);
      if (res.data.status === 200) {
        setUser(res.data.data.solarlisting);
        setTotal(res.data.data.total);
      }
    } catch (err) {
      console.log(err);
    }
  };

  //**************************** Download Excel File ************************ */

  const downloadExcleFile = async () => {
    // console.log("hello")
    try {
      setSubmitLoading(true)
      const response = await axios.get(`${Url}/solarRequest/exportSolarUser`, {
        params: {
          search: debounceValue,
          startDate: startDate ? new Date(startDate).toISOString() : "",
          endDate: endDate ? new Date(endDate).toISOString() : ""
        },
        responseType: 'blob',
      });

  

      if (response.status === 200) {
        setSubmitLoading(false)
        const currentDate = new Date();
        const formattedDate = currentDate.toISOString().slice(0, 10);

        let rnFile = `${formattedDate}.xlsx`;

        // Extract the filename from the response headers
        const contentDisposition = response.headers['content-disposition'];
        console.log("contentDisposition", contentDisposition)
        // return false
        const matches = /filename="([^"]+)"/.exec(contentDisposition);
        const filename = matches ? matches[1] : 'excel-file.xlsx';


        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // link.setAttribute('download', `user_${new Date().getTime()}.xlsx`);
        link.setAttribute('download', `user_${rnFile}`);
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      } else {
        setSubmitLoading(false)

        toast.error('Something went to wrong')
      }
    } catch (error) {
      setSubmitLoading(false)

      console.error('Error downloading file:', error);
    }
  };


  useEffect(() => {
    handelSolarRequest(requestType, activePage, debounceValue);
  }, [debounceValue]);

  // useEffect(() => {
  //   localStorage.setItem("solarActivePage", activePage)
  // }, [activePage])
  const handlePageChange = (pageNo) => {
  
    setActivePage(pageNo);
    handelSolarRequest(requestType, pageNo);
   
  };
  const handelSearch = (e) => {
    // handelSolarRequest(requestType, activePage, e.target.value);
    setSearchValue(e.target.value)
  };
  const handleLimitChange = (e) => {
   
    setLimit(
   e.target.value
    );
    setActivePage(1)
  };


  useEffect(() => {
    localStorage.setItem("userActivePage", activePage);
    handelSolarRequest(requestType, activePage, debounceValue);
  }, [activePage, debounceValue, startDate, endDate,limit]);

  // useEffect(() => {
  //   if (startDate && endDate) {
  //     handelSolarRequest(requestType, activePage, debounceValue)
  //   }
  // }, [startDate, endDate])

  useEffect(() => {
    handelSolarRequest()
  }, [])




  var count = (activePage - 1) * 10 + 1;
  // var count = limit === 'all' ? total : parseInt(limit, 10);

  return (
    <React.Fragment>
      <title>Solar Request Management</title>
      <div className="WrapperArea soloar_request">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <div className="customInput">

                <input type="text" placeholder="Search" onChange={handelSearch} />
              </div>
              {/* <a
                className="customBtn"
                href={`${Url}/solarRequest/exportSolarUser?search=${debounceValue}&startDate=${startDate !== "" ? new Date(startDate).toISOString() : ""}&endDate=${endDate !== "" ? new Date(endDate).toISOString() : ""}`}
                target="__blank"
              >
                <i className="fa fa-file-excel-o" aria-hidden="true"></i>{" "}
                Download
              </a> */}
              {/* <button className="customBtn" onClick={() => downloadExcleFile()}> <i className="fa fa-file-excel-o" aria-hidden="true"></i>{" "}
                Download</button> */}
              <button
                className="button"
                onClick={downloadExcleFile}
                ref={submitButtonElement}
              >
                download
              </button>
            </div>

            <div className="SearchBox">
         
              {/* <button>Apply</button> */}
              <div className="customInput">
                <DatePicker
                  placeholderText="Start Date"
                  className="input input1"
                  selectsStart
                  startDate={startDate}
                  selected={startDate}
                  value={startDate}
                  showYearDropdown
                  yearDropdownItemNumber={100}
                  scrollableYearDropdown
                  showMonthDropdown
                  useShortMonthInDropdown
                  onChange={(date) => date ? setStartDate(date) : setStartDate("")}
                  dateFormat="yyyy-MM-dd"
                // maxDate={new Date(endDate)}
                />
              </div>

              <div className="customInput">
                <div className="form-field date-picker ">
                  <DatePicker
                    placeholderText="End Date"
                    // className="input dataPickerWidth"
                    selected={endDate}
                    value={endDate}
                    showYearDropdown
                    yearDropdownItemNumber={100}
                    scrollableYearDropdown
                    showMonthDropdown
                    useShortMonthInDropdown
                    onChange={(date) => date ? setEndDate(date) : setEndDate("")}
                    dateFormat="yyyy-MM-dd"
                    minDate={new Date(startDate)}
                  />
                </div>
              </div>
              <select
                  className="mx-2 cstm_select_select_drop"
                  value={limit}
                  // onChange={(e) => setLimit(e.target.value)}
                  onChange={handleLimitChange}
                  style={{ padding: '0.25rem', height: '2.5rem' }}
                >
                  <option value="10">10 </option>
                  <option value="50">50 </option>
                  <option value="100">100 </option>
                  <option value="500">500 </option>
                  <option value="all">All </option>
                </select>
            </div>
            <h4 className="Title">
              Solar Request Management
              {/* <Link to="/category/add">Add New Document</Link> */}
            </h4>
            {/* 
            <ul className="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                  onClick={() => {
                    handelSolarRequest("NotYet");
                  }}
                >
                  Pending Request
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                  onClick={() => {
                    handelSolarRequest("ReferToVolt");
                  }}
                >
                  Financed By Volt
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  id="pills-contact-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-contact"
                  aria-selected="false"
                  onClick={() => {
                    handelSolarRequest("ReferToFinance");
                  }}
                >
                  Financed By Partner
                </button>
              </li>
            </ul> */}
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <div className="TableList table-responsive">
                  {loader}
                  <table>
                    <thead>
                      <tr>
                        <th>S.No</th>
                        <th>Username</th>
                        <th>Company Name</th>
                        <th>Mobile Number</th>
                        {/* <th>State</th> */}
                        <th>Request Date</th>
                        <th>Total Reuest Send</th>
                        <th>Financed Status</th>

                        <th>View</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users &&
                        users.length > 0 &&
                        users.map((item, i) => (
                          <tr key={i}>
                            <td>{count++}</td>
                            <td>
                              {item.firstName && item.lastName
                                ? item.firstName + " " + item.lastName
                                : "- - -"}
                            </td>
                            <td>{item.nameOfBusiness}</td>
                            <td>{item.contactNum}</td>
                            {/* <td>{item.stateName}</td> */}
                            <td>{dateFormat(item.createdAt)}</td>
                            {/* <td>{item.state}</td> */}

                            <td>{item.sendRequest}</td>
                            <td>
                              {item.approvedByAdminStatus === "Pending" &&
                                item.sendRequest > 0 ? (
                                "Under Processing"
                              ) : (
                                <>
                                  {item.approvedByAdminStatus === "Pending" &&
                                    item.sendRequest === 0 ? (
                                    "Pending"
                                  ) : (
                                    <>
                                      {item.approvedByAdminStatus ===
                                        "Approved" ? (
                                        "Approved"
                                      ) : (
                                        <>
                                          {item.approvedByAdminStatus ===
                                            "Rejected"
                                            ? "Rejected"
                                            : "- - -"}
                                        </>
                                      )}
                                    </>
                                  )}
                                </>
                              )}

                              {/* {item.sendRequest === 0
                                ? 'Pending'
                                : item.sendRequest > 0 && item.approvedByAdminStatus === 'Pending'
                                ? "Under Processing"
                                : 'Request '+item.approvedByAdminStatus} */}
                            </td>

                            <td>
                              <Link
                                to={`/solar-request/details/${item.userId}`}
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                {total > 10 ? (
                  <div className="Pagination">
                    <Pagination
                      activePage={activePage}
                      previousLabel={"previous"}
                      nextLabel={"next"}
                      itemsCountPerPage={limit}
                      totalItemsCount={total}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="ModalBox">
        {/* block or unblock model */}
        {/* <Modal
          show={BlockModal}
          style={{ opacity: 1 }}
          onHide={handleBlockClose}
        >
          <Modal.Header closeButton onClick={handleBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button className="secondary" variant="secondary" onClick={handleBlockClose}>
              No
            </button>
            <button className="primary" variant="primary" onClick={updateStatus}>
              Yes
            </button>
          </Modal.Footer>
        </Modal> */}
        {/* end block unblock modal */}
      </div>
    </React.Fragment>
  );
}
